import axios from "axios"
import {
  GET_USER_PROFILE_API_URL,
  GET_USER_PROFILE_UPDATE_API_URL,
} from "../helpers/constants/constants"

const generaluser = {
  getProfile() {
    return axios.get(GET_USER_PROFILE_API_URL)
  },

  updateProfile(slug, data) {
    if (!slug) throw "updateProfile: received empty slug"
    return axios.patch(`${GET_USER_PROFILE_UPDATE_API_URL}${slug}/`, data)
  },
}

export default generaluser
